import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto, seleccionarCampo
} from '../../util/varios';

 
import axios from 'axios';
import useTableFijo from '../useTableFijo';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import { AgregarCuentasGastos } from './modalAgregarCuentasGastos';
import CatalogoCuentasPresuGastos from '../../catalogos/catalogoCuentasPresupuestariasGastos';


function TablaCodificacionAjusteCompromiso(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Sec', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Prog', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Spro', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Proy', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Act', textAlign: 'center' },
        { id: '6', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Par', textAlign: 'center' },
        { id: '7', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Gen', textAlign: 'center' },
        { id: '8', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Esp', textAlign: 'center' },
        { id: '9', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Sub', textAlign: 'center' },
        { id: '10', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Ord', textAlign: 'center' },
        { id: '11', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Concepto', textAlign: 'center' },
        { id: '12', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto Compromiso', textAlign: 'center' },
        { id: '13', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto Caudado', textAlign: 'center' },
        { id: '14', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Disponible / Causar', textAlign: 'center' },
        { id: '15', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto a Ajustar', textAlign: 'center' },
    ]

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [mostrar9, setMostrar9] = useState(false);
    const [activate, setActivate] = useState(false);
    const [iva, setIva] = useState(0);
    const [operacion, setOperacion] = useState(0);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [habiPorce, setHabiporce] = useState(false);
    const txtDescriclas = useRef([]);
    const txtMontoTotalAjuste = useRef();
    const txtMontoCompromiso = useRef();
    const txtIva = useRef();
    const txtMontoiva = useRef();
    const txtMontoAjuste = useRef([]);
    const txtMontoPresupuestado = useRef();
    const txtMontoDisponible = useRef();
    const txtBtnIncluir = useRef();
    const [val1, setVal1] = useState(0);
    const [val2, setVal2] = useState(0);
    const [valor1, setValor1] = useState('00');
    const [valor2, setValor2] = useState('00');
    const [valor3, setValor3] = useState('00');
    const [valor4, setValor4] = useState('00');
    const [valor5, setValor5] = useState('00');
    const [valor6, setValor6] = useState('000');
    const [valor7, setValor7] = useState('00');
    const [valor8, setValor8] = useState('00');
    const [valor9, setValor9] = useState('00');
    const [valor10, setValor10] = useState('0000');
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [idcta, setIdCta] = useState(0);
    const [idctan, setIdCtaN] = useState(0);
    const [idmov, setIdMov] = useState(0);
    const [dataRecords, setDataRecords] = useState();

    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivo(true);
        setItemSelect(-1);
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const handleCloseMensa = () => {
        setMostrar(false);
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }

    const seleccionarIva = (id) => {

        let campos = "*"
        let nomtab = "iva";
        let nomid = "idiva";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.idiva > 0) {
                    setIva(response.data.porcentaje);
                } else {
                    setIva(0.00);
                }

            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    useEffect(() => {
        seleccionarIva(1);
    }, []);


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        blanquearCampos();

        if (ope === 1) {
            if (props.idprov === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe primero seleccionar un proveedor', icono: 'informacion' });
                return;
            }
            setMostrar5(true);
            setOperacion(1);
            blanquearCampos()

        } if (ope === 3) {

        }

    }

    useEffect(() => {

        if (props.datarecords && props.datarecords.length > 0) {
            var data1 = [...props.datarecords];
            if (props.operacion === 1){
                for (let i = 0; i < data1.length; i++) {
                    data1[i].montoajuste =  parseFloat(data1[i].monto) - parseFloat(data1[i].montocausado) - parseFloat(data1[i].montoajustado);
                    data1[i].montodispo = parseFloat(data1[i].monto) - parseFloat(data1[i].montocausado) - parseFloat(data1[i].montoajustado);
                }
                //setDataRecords(data1);
            } else {
                for (let i = 0; i < data1.length; i++) {
                    data1[i].montodispo = parseFloat(data1[i].monto) - parseFloat(data1[i].montocausado);
                }
                //setDataRecords(props.datarecords);
            }
            setDataRecords(data1);

            if (props.operacion === 3) {

                var data = [...props.datarecords];
                var datos = [];

                for (let i = 0; i < data.length; i++) {

                    datos.push({
                        idcuenta: data[i].idcuenta,
                        auxiliar: data[i].auxiliar,
                        monto: data[i].monto,
                        idcat: data[i].idcategoria,
                        idpuc: data[i].idpuc,

                    });

                }
                props.data(datos);
            } 


        } else {
            txtMontoTotalAjuste.current.value = '0,00';
            txtMontoCompromiso.current.value = '0,00';
            setRecords([]);
        }

    }, [props.datarecords]);

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);
        for (let i = 0; i < records.length; i++) {
            for (let z = 0; z < datos.length; z++) {
                if (records[i].idcuenta === datos[z].idcuenta) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Tipo de Compromiso', icono: 'informacion' });
                }
            }

        }
        let data = [...records];


        for (let i = 0; i < datos.length; i++) {

            data.push({
                uno: datos[i].uno,
                dos: datos[i].dos,
                tres: datos[i].tres,
                cuatro: datos[i].cuatro,
                cinco: datos[i].cinco,
                seis: datos[i].seis,
                siete: datos[i].siete,
                ocho: datos[i].ocho,
                nueve: datos[i].nueve,
                auxiliar: datos[i].auxiliar,
                descripcion: datos[i].descripcion,
                montoinicial: datos[i].montoinicial,
                disponible: datos[i].disponible,
                monto: datos[i].monto,
                /*montocausado: datos[i].montocausado,
                montoajustado: datos[i].montoajustado,*/
                idcuenta: datos[i].idcuenta,
                idcat: datos[i].idcat,
                idpuc: datos[i].idpuc,
                descripcionaux: datos[i].descripcionaux,
                descripcat: '',
                descrippuc: '',
                //idmovimiento: data[i].idmovimiento,

            });

        }

        let total = 0.00;
        let montoiva = 0.00;

        for (let e = 0; e < data.length; e++) {
            total = parseFloat(total) + parseFloat(data[e].monto);
        }

        //montoiva = total * iva / 100;

        txtMontoTotalAjuste.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        txtMontoCompromiso.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        if (props.tipo === 12) {
            if (props.exento === false) {
                montoiva = Math.round(parseFloat(total) * parseFloat(iva) / (100 + parseFloat(iva)) * Math.pow(10, 4)) / Math.pow(10, 4);
                /*txtMontoiva.current.value = formatMoneda(montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                txtIva.current.value = formatMoneda(iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);*/
            } else {
                /*txtMontoiva.current.value = '0,00';
                txtIva.current.value = '0,00';*/
            }
        }

        setRecords(data);
        props.data(data, montoiva);
    }

    useEffect(() => {
        txtMontoTotalAjuste.current.value = '0,00';
        txtMontoCompromiso.current.value = '0,00';
        //txtMontoiva.current.value = '0,00';
        if (props.tipo === 5 || props.tipo === 7 || props.tipo === 11 || props.tipo === 13 || props.tipo === 23 || props.tipo === 24 || props.tipo === 26) {
            setHabiporce(false);
            //txtIva.current.value = '0,00'
            if (props.datarecords && props.datarecords.length > 0) {
                //txtMontoiva.current.value = formatMoneda(props.datarecords[0].montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            }

        } else if (props.tipo === 12) {
            if (props.exento === false) {
                setHabiporce(true);
                //txtIva.current.value = formatMoneda(iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            } else {
                setHabiporce(false);
                //txtIva.current.value = '0,00'
                //setIva(0.00);
            }

        }
        //if (props.datarecords && props.datarecords.length > 0 && props.datarecords[0].idcuenta > 0) {
        if (dataRecords && dataRecords.length > 0 && dataRecords[0].idcuenta > 0) {  

            //var data = [...props.datarecords];
            var data = [...dataRecords];
            var datos = [];
            setHabiporce(false);
            //txtIva.current.value = '0,00'

            for (let i = 0; i < data.length; i++) {

                datos.push({

                    uno: data[i].cuenta.substring(0, 2),
                    dos: data[i].cuenta.substring(2, 4),
                    tres: data[i].cuenta.substring(4, 6),
                    cuatro: data[i].cuenta.substring(6, 8),
                    cinco: data[i].cuenta.substring(8, 10),
                    seis: data[i].cuenta.substring(10, 13),
                    siete: data[i].cuenta.substring(13, 15),
                    ocho: data[i].cuenta.substring(15, 17),
                    nueve: data[i].cuenta.substring(17, 19),
                    auxiliar: data[i].auxiliar,
                    descripcat: data[i].descripcat,
                    descrippuc: data[i].descrippuc,
                    monto: data[i].monto,
                    montocausado: data[i].montocausado,
                    montoajustado: data[i].montoajustado,
                    montoinicial: data[i].montoinicial,
                    montodispo: data[i].montodispo,
                    disponible: data[i].disponibilidad,
                    descripcionaux: data[i].descripcionaux,
                    idcat: data[i].idcategoria,
                    idpuc: data[i].idpuc,
                    idcuenta: data[i].idcuenta,
                    idmovimiento: data[i].idmovimiento,
                    montoajuste: data[i].montoajuste
                });

            }

            let total = 0.00;
            let totalaju = 0.00;
            for (let e = 0; e < data.length; e++) {
                total = parseFloat(total) + parseFloat(data[e].monto);
                totalaju = parseFloat(totalaju) + parseFloat(data[e].montoajuste);
            }

            txtMontoTotalAjuste.current.value = formatMoneda(totalaju.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            txtMontoCompromiso.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            //txtMontoiva.current.value = formatMoneda(props.datarecords[0].montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            setRecords(datos);
            props.data(datos, props.datarecords[0].montoiva, idcta, idctan, idmov);
        } else {
            setRecords([]);
        }

    //}, [props.datarecords, props.exento, idcta, idctan, idmov]);
    }, [dataRecords, props.exento, idcta, idctan, idmov]);

    const eliminarPresupuesto = (item) => (e) => {
        e.preventDefault();

        var datos = [...records];
        var elementos = [];
        var blanquea = [];

        for (let i = 0; i < datos.length; i++) {

            if (item.idcuenta !== datos[i].idcuenta) {
                elementos.push(datos[i]);
            }

        }

        let total = 0.00;
        let montoiva = 0.00;
        for (let e = 0; e < elementos.length; e++) {
            total = parseFloat(total) + parseFloat(elementos[e].monto);
        }
        //montoiva = total * iva / 100 + iva;
        montoiva = Math.round(parseFloat(total) * parseFloat(iva) / (100 + parseFloat(iva)) * Math.pow(10, 4)) / Math.pow(10, 4);

        txtMontoTotalAjuste.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        txtMontoCompromiso.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        /*txtIva.current.value = formatMoneda(iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        txtMontoiva.current.value = formatMoneda(montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);*/

        blanquea.push({

            uno: "",
            dos: "",
            tres: "",
            cuatro: "",
            descripcion: "",
            monto: ""

        });

        setRecords(elementos);
        props.data(elementos);
    }

    const validarMonto = (index) => (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '1,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '1,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.length);
            }
            if (event.target.id === 'monto') {

                let data = [...records];

                var monto = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.'));

                data[index].monto = monto;

                let total = 0.00;

                for (let i = 0; i < data.length; i++) {
                    total = parseFloat(total) + parseFloat(data[i].monto);
                }

                txtMontoTotalAjuste.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                txtMontoCompromiso.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                setRecords(data);
                props.data(data);

            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleCloseSi = () => {

        setActivate(false);

    };

    const handleInputMontoChange = (event) => {

        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '1,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.target.id === 'montoajuste') {
                if (parseFloat(txtMontoAjuste.current[itemSelect].value.trim().replace(/\./g, '').replace(',', '.')) > parseFloat(records[itemSelect].monto - records[itemSelect].montocausado)){
                    event.target.value = '0,00';
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto no Puede ser Mayor al Monto Compromiso', icono: 'informacion' });
                    txtMontoAjuste.current[itemSelect].value = '0,00';
                    txtMontoAjuste.current[itemSelect].focus();
                    return;
                }
                
            }
            if (event.which === 13) {
                if (event.target.id === 'montoajuste') {
                    let data = [...records];
                    //data[index].montodeclarado = event.target.value;
                    //data[index].montodeclarado = formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.');
                    data[itemSelect].montoajuste = parseFloat(event.target.value.trim().replace(/\./g, '').replace(',', '.'));
                    setRecords(data);
                    let data1 = [...dataRecords];
                    data1[itemSelect].montoajuste = parseFloat(event.target.value.trim().replace(/\./g, '').replace(',', '.'));
                    setDataRecords(data1);
                    data[itemSelect].montoajuste = parseFloat(event.target.value.trim().replace(/\./g, '').replace(',', '.'));
                    props.data(data, props.datarecords[0].montoiva, idcta, idctan, idmov);
                    if (itemSelect === records.length-1){
                        txtMontoAjuste.current[itemSelect].focus();
                    } else {
                        setItemSelect(itemSelect + 1);
                        setTimeout(() => {
                            txtMontoPresupuestado.current.value = formatMoneda((parseFloat(records[itemSelect + 1].monto) - parseFloat(records[itemSelect + 1].montocausado) - parseFloat(records[itemSelect + 1].montoajustado)).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                            txtMontoDisponible.current.value = formatMoneda(parseFloat(records[itemSelect + 1].disponible).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                            txtMontoAjuste.current[itemSelect + 1].focus();
                        }, 200);
                        
                    }
                    
                    let total = 0.00;
                    for (let e = 0; e < records.length; e++) {
                        total = parseFloat(total) + parseFloat(txtMontoAjuste.current[e].value.trim().replace(/\./g, '').replace(',', '.'));
                    }
        
                    txtMontoTotalAjuste.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    
                } else if (event.target.id === 'inputReintegro' || event.target.id === 'inputRetenciones') {
                    //btnProcesar.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const catalogoClass = (e) => {
        e.preventDefault();
        if (itemSelect >= 0) {
            //setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'ID Cuenta a Cambiar' + recordsAfterPagingAndSorting()[itemSelect].descripcionaux !== '' ? recordsAfterPagingAndSorting()[itemSelect].descripcionaux : recordsAfterPagingAndSorting()[itemSelect].descripcat !== '' ? recordsAfterPagingAndSorting()[itemSelect].descripcat + '(' + recordsAfterPagingAndSorting()[itemSelect].descrippuc + ')' : recordsAfterPagingAndSorting()[itemSelect].descripcion, icono: 'informacion' });
            setMostrar9(true);
        } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar la Cuenta a Cambiar', icono: 'informacion' });
        }

    };

    const handleCancelaCuentas = () => {
        setMostrar9(false);
    }

    const handleAceptaClasPresupuestaria = (cuenta, descripcion, auxiliar, disponible, idcuenta, idcat, idpuc, descriaux, montoinicial) => {
        setMostrar9(false);
        txtDescriclas.current.value = descripcion.trim();
        setValor1(cuenta.substring(0, 2));
        setValor2(cuenta.substring(2, 4));
        setValor3(cuenta.substring(4, 6));
        setValor4(cuenta.substring(6, 8));
        setValor5(cuenta.substring(8, 10));
        setValor6(cuenta.substring(10, 13));
        setValor7(cuenta.substring(13, 15));
        setValor8(cuenta.substring(15, 17));
        setValor9(cuenta.substring(17, 19));
        setValor10(auxiliar.trim());
        setIdCtaN(idcuenta);
        /*txtId.current.value = idcuenta;
        txtPuc.current.value = idpuc;
        txtCat.current.value = idcat;
        txtDescriaux.current.value = descriaux;
        txtDisponible.current.value = formatMoneda(disponible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        setMontocuenta(formatMoneda(disponible.toString().replace(',', '').replace('.', ','), ',', '.', 2));
        setMonIni(montoinicial);*/

    }

    const seleccionarFila = (index) => (e) => {
        if (props.operacion === 1){
            e.preventDefault();
            setActivo(false);
            setItemSelect(index);
            /*setIdCta(recordsAfterPagingAndSorting()[index].idcuenta);
            setIdMov(recordsAfterPagingAndSorting()[index].idmovimiento);
            txtMontoPresupuestado.current.value = formatMoneda((parseFloat(recordsAfterPagingAndSorting()[index].monto) - parseFloat(recordsAfterPagingAndSorting()[index].montocausado) - parseFloat(recordsAfterPagingAndSorting()[index].montoajustado)).toString().replace(',', '').replace('.', ','), ',', '.', 2);
            txtMontoDisponible.current.value = formatMoneda(parseFloat(recordsAfterPagingAndSorting()[index].disponible).toString().replace(',', '').replace('.', ','), ',', '.', 2);*/
            setIdCta(records[index].idcuenta);
            setIdMov(records[index].idmovimiento);
            txtMontoPresupuestado.current.value = formatMoneda((parseFloat(records[index].monto) - parseFloat(records[index].montocausado) - parseFloat(records[index].montoajustado)).toString().replace(',', '').replace('.', ','), ',', '.', 2);
            txtMontoDisponible.current.value = formatMoneda(parseFloat(records[index].disponible).toString().replace(',', '').replace('.', ','), ',', '.', 2);
        }
       
    };

    return (
        <div>

            <CatalogoCuentasPresuGastos
                show={mostrar9}
                val={val1}
                vals={val2}
                onHideCancelar={handleCancelaCuentas}
                onHideAceptaClasPresupuestaria={handleAceptaClasPresupuestaria}
            />
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>

            <div className="row col-md-12 mx-auto m-0">
                <div className='col-sm-9'></div>

                <div className='col-sm-3 ml-auto px-0 mb-1'>
                    <div className="input-group input-group-sm m-0 w-100">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Monto del Compromiso:</label>
                        <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoCompromiso} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                    </div>
                </div>
                <div className="col-md-12 m-0 px-0 mb-1">
                    <TblContainer container={{ height: 170, width: '100%', overflow: 'auto', padding: '2px' }}>
                        <TblHead />

                        <tbody>
                            {

                                /*records && recordsAfterPagingAndSorting().map((item, index) => (*/
                                records && records.map((item, index) => (
                                    <tr key={item + item.idcuenta} className="table-bordered" style={{ padding: "0", height: '40px', cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.uno}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.dos}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.tres} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.cuatro} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '20px' }}>{item.cinco} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.seis} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.siete} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.ocho} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.nueve} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '20px' }}>{item.auxiliar} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '150px' }}>{item.descripcionaux !== '' ? item.descripcionaux : item.descripcat !== '' ? item.descripcat + '(' + item.descrippuc + ')' : item.descripcion} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "right", width: '50px' }}>{formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "right", width: '50px' }}>{formatMoneda(item.montocausado.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "right", width: '50px' }}>{formatMoneda(item.montodispo.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "right", width: '80px' }}>
                                            <input type="text" disabled={props.operacion === 1 ? false : true} autoComplete='off' className="form-control text-right" ref={el => txtMontoAjuste.current[index] = el} defaultValue={formatMoneda((item.montoajuste).toString().replace(',', '').replace('.', ','), ',', '.', 2)} onFocus={seleccionarCampo} onBlur={handleInputMontoChange} onKeyUp={handleInputMontoChange} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="montoajuste" />
                                        </td>

                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    {/* <TblPagination /> */}

                </div>

                <div className='col-md-12 m-0 px-0 mb-1 row'>

                    <fieldset className="row border-azul rounded mx-auto col-sm-8">

                        <div className='container row m-0 d-flex justify-content-center col-12 mx-auto px-0'>

                            <div className='mb-2'></div>

                            <div className='col-md-12 m-0 px-0'>
                                <div className='col-sm-7 mb-2 px-0'></div>
                                <div className='col-sm-5 mb-2 px-0'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Presupuesto Ejercicio:</label>
                                        <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoPresupuestado} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-12 px-0'>
                                <div className='col-sm-7 mb-2 px-0'></div>
                                <div className='col-sm-5 mb-2 px-0'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Disponibilidad:</label>
                                        <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoDisponible} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </fieldset>
                    <div className='col-sm-1'></div>
                    <div className='col-sm-3'>
                        <div className='col-sm-11 ml-auto px-0'>
                            <div className="input-group input-group-sm m-0 w-100">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Total Bs.:</label>
                                <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoTotalAjuste} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                            </div>
                        </div>
                        {/*<div className='col-sm-11 ml-auto px-0'>
                            <div className="input-group input-group-sm m-0 w-100">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Porcentaje IVA:</label>
                                <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={!habiPorce} ref={txtIva} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="porceiva" onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
                            </div>
                        </div>
                        <div className='col-sm-11 ml-auto px-0'>
                            <div className="input-group input-group-sm m-0 w-100">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Monto IVA:</label>
                                <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoiva} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                            </div>
                        </div>*/}
                    </div>
                </div>
            </div>


        </div>

    );

}

export default TablaCodificacionAjusteCompromiso;
